function focus_on_first_form_error()
{
    let firstError = document.querySelector(".is-invalid, .validationError");
    if(firstError != null)
    {
        var containerAccordion = firstError.closest(".accordion-collapse");
        if(containerAccordion) {
            window.blazorBootstrap.collapse.show(containerAccordion.id);
            setTimeout(() => {}, 1000);
        }
        firstError.focus();
    }
}

function focus_on_next_focusable_element()
{
    // Get all focusable elements
    const focusableElements = document.querySelectorAll(
    'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
    );

    const currentIndex = Array.from(focusableElements).indexOf(document.activeElement);
  
    if (currentIndex >= 0 && currentIndex < focusableElements.length - 1) {
        // Focus the next element in the array
        focusableElements[currentIndex + 1].focus();
    } else {
        // If no element is currently focused or at the end, focus the first one
        focusableElements[0]?.focus();
    }
}

function focus_on_element(selector) {
    const el = document.querySelector(selector);
    if(el) {
        el.focus();
    }
}

function scroll_into_view(selector) {
    const el = document.querySelector(selector);
    if(el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
}

function mask_input(el) {
    if (el) {
        let maskOptions = {};
        if("regex" in el.dataset) {
            maskOptions.mask = new RegExp(el.dataset.regex);
        }
        else if("mask" in el.dataset) {
            if(el.dataset.mask == "Number") {
                maskOptions.mask = Number;
            } else {
                maskOptions.mask = el.dataset.mask;
            }
        }
        if("min" in el.dataset) {
            maskOptions.min = el.dataset.min;
        }
        if("max" in el.dataset) {
            maskOptions.max = el.dataset.max;
        }
        el.dataset.masked = true;
        IMask(el, maskOptions);
    }
}

function resetModalBodyStyles() {
    document.body.classList.remove("modal-open");
    document.body.style.overflow = "auto";
    document.body.style.paddingRight = '';
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop)
    {
        backdrop.remove();
    }
};

// Mask Inputs
const observer = new MutationObserver((mutationsList, observer) => {
    for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
            const maskedInputs = document.querySelectorAll('[data-mask]:not([data-masked])');
            if (maskedInputs.length > 0) {
                maskedInputs.forEach(mask_input);
            }
            const recaptchaElements = document.querySelectorAll('.g-recaptcha-response');
            recaptchaElements.forEach((el) => {
                el.setAttribute('aria-hidden', 'true');
                el.setAttribute('aria-label', 'hidden');
            });
        }
    }
});

// Start observing the document body for added nodes
observer.observe(document, { childList: true, subtree: true });

document.addEventListener('click', function(event) {
    if (event.target && event.target.id === 'skip-to-main-content') {
        const mainContent = document.getElementById("main-content");
        if(mainContent) {
            mainContent.focus();
        }
    }
});